var isCallable = require('../internals/is-callable');

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-possible-prototype.js
// module id = 1238
// module chunks = 1